import styled, { keyframes } from 'styled-components';

/**
 * Two-keyframe rotation. We don't pause/resume on hover or visibility because
 * the spinner is decorative — the parent owns the lifecycle (mount = active,
 * unmount = stopped). Adding `prefers-reduced-motion` would defeat the point
 * of an indeterminate progress indicator (the user has no other progress
 * signal), so we deliberately keep it animating in all environments.
 */
const spin = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
`;

/**
 * Diameter, stroke width, and shape are passed via inline `style` (see
 * `Spinner.tsx`) rather than styled-component props because they vary per
 * call site: hashing a class per `(diameter, stroke)` combo would churn the
 * stylesheet for no benefit. The static rules below cover everything that
 * doesn't change between instances.
 */
export const Root = styled.span`
  display: inline-block;
  flex-shrink: 0;
  vertical-align: middle;
  border-style: solid;
  border-color: currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: ${spin} 700ms linear infinite;
`;
